import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/PromoCode`;

const headers = {
  'Content-Type': 'multipart/form-data',

};

const PromoCode = {
  getAll: (params) => {
    const url = `${baseServiceUrl}`;
    return ServiceApi.get(url, { params });
  },
  get: (id) => {
    const url = `${baseServiceUrl}/${id}`;
    return ServiceApi.get(url);
  },
  getAllPromoCodeQuery: (params) => {
    const url = `${baseServiceUrl}/getAllPromoCode`;
    return ServiceApi.get(url, { params });
  },
  getAgentById: (params) => {
    const url = `${baseServiceUrl}/getAgentById?id=` + params; return ServiceApi.get(url, { params });
  },
  createandEditPromoCode: (params) => {
    const url = `${baseServiceUrl}/addOrEditPromoCode`;
    return ServiceApi.post(url, params);
  },
  getNewPromoCodeQuery: () => {
    const url = `${baseServiceUrl}/getNewPromoCodeQuery`;
    return ServiceApi.get(url);
  },
  getAllPublicPromoCode: (params) => {
    const url = `${baseServiceUrl}/GetAllPublicPromoCode`;
    return ServiceApi.get(url, { params });
  },
  updateExpireDatePublicPromoCode: (params) => {
    const url = `${baseServiceUrl}/UpdatePublicPromoCode`
    return ServiceApi.put(url, params)
  },
  createPublicPromoCode: (params) => {
    const url = `${baseServiceUrl}/createPublicPromoCode`
    return ServiceApi.post(url, params)
  },
  createOrEditPrivatePromoCode: (params) => {
    const url = `${baseServiceUrl}/createOrEditPrivatePromoCode`
    return ServiceApi.post(url, params)
  },
  changeStatusPromoCode: (params) => {
    const url = `${baseServiceUrl}/changeStatusPromoCode`
    return ServiceApi.put(url, params)
  }
};

export default PromoCode;


